<template>
  <transition name="zm-loading-fade" @after-leave="handleAfterLeave">
    <div
      v-show="visible"
      class="zm-loading-mask"
      :style="{ backgroundColor: background || '' }"
      :class="[customClass, { 'is-fullscreen': fullscreen }]"
    >
      <div class="zm-loading-spinner">
        <svg v-if="!spinner" class="circular" width="50" height="50" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M8 0.375C8.34518 0.375 8.625 0.654822 8.625 1V4C8.625 4.34518 8.34518 4.625 8 4.625C7.65482 4.625 7.375 4.34518 7.375 4V1C7.375 0.654822 7.65482 0.375 8 0.375Z" fill="#000001" />
          <path opacity="0.9" fill-rule="evenodd" clip-rule="evenodd" d="M4.18775 1.39655C4.48668 1.22396 4.86893 1.32638 5.04152 1.62531L6.54152 4.22339C6.71411 4.52232 6.61168 4.90456 6.31275 5.07715C6.01382 5.24974 5.63157 5.14732 5.45898 4.84839L3.95898 2.25031C3.7864 1.95138 3.88882 1.56913 4.18775 1.39655Z" fill="#000001" />
          <path opacity="0.8" fill-rule="evenodd" clip-rule="evenodd" d="M1.39648 4.18752C1.56907 3.88859 1.95132 3.78617 2.25025 3.95876L4.84833 5.45876C5.14726 5.63135 5.24968 6.01359 5.07709 6.31252C4.9045 6.61146 4.52226 6.71388 4.22333 6.54129L1.62525 5.04129C1.32632 4.8687 1.2239 4.48646 1.39648 4.18752Z" fill="#000001" />
          <path opacity="0.7" fill-rule="evenodd" clip-rule="evenodd" d="M0.375 8C0.375 7.65482 0.654822 7.375 1 7.375H4C4.34518 7.375 4.625 7.65482 4.625 8C4.625 8.34518 4.34518 8.625 4 8.625H1C0.654822 8.625 0.375 8.34518 0.375 8Z" fill="#000001" />
          <path opacity="0.6" fill-rule="evenodd" clip-rule="evenodd" d="M1.39648 11.8125C1.2239 11.5136 1.32632 11.1313 1.62525 10.9587L4.22333 9.45873C4.52226 9.28614 4.9045 9.38856 5.07709 9.68749C5.24968 9.98643 5.14726 10.3687 4.84833 10.5413L2.25025 12.0413C1.95132 12.2138 1.56907 12.1114 1.39648 11.8125Z" fill="#000001" />
          <path opacity="0.5" fill-rule="evenodd" clip-rule="evenodd" d="M4.18725 14.6035C3.88832 14.4309 3.78589 14.0486 3.95848 13.7497L5.45848 11.1516C5.63107 10.8527 6.01332 10.7503 6.31225 10.9228C6.61118 11.0954 6.7136 11.4777 6.54102 11.7766L5.04102 14.3747C4.86843 14.6736 4.48618 14.776 4.18725 14.6035Z" fill="#000001" />
          <path opacity="0.4" fill-rule="evenodd" clip-rule="evenodd" d="M8 15.6272C7.65482 15.6272 7.375 15.3473 7.375 15.0022V12.0022C7.375 11.657 7.65482 11.3772 8 11.3772C8.34518 11.3772 8.625 11.657 8.625 12.0022V15.0022C8.625 15.3473 8.34518 15.6272 8 15.6272Z" fill="#000001" />
          <path opacity="0.3" fill-rule="evenodd" clip-rule="evenodd" d="M11.8122 14.6056C11.5133 14.7782 11.1311 14.6758 10.9585 14.3768L9.45848 11.7787C9.28589 11.4798 9.38832 11.0976 9.68725 10.925C9.98618 10.7524 10.3684 10.8548 10.541 11.1537L12.041 13.7518C12.2136 14.0508 12.1112 14.433 11.8122 14.6056Z" fill="#000001" />
          <path opacity="0.3" fill-rule="evenodd" clip-rule="evenodd" d="M14.6035 11.8147C14.4309 12.1136 14.0487 12.216 13.7497 12.0434L11.1517 10.5434C10.8527 10.3708 10.7503 9.98861 10.9229 9.68967C11.0955 9.39074 11.4777 9.28832 11.7767 9.46091L14.3747 10.9609C14.6737 11.1335 14.7761 11.5157 14.6035 11.8147Z" fill="#000001" />
          <path opacity="0.2" fill-rule="evenodd" clip-rule="evenodd" d="M15.625 8.00217C15.625 8.34734 15.3452 8.62717 15 8.62717H12C11.6548 8.62717 11.375 8.34734 11.375 8.00217C11.375 7.65699 11.6548 7.37717 12 7.37717H15C15.3452 7.37717 15.625 7.65699 15.625 8.00217Z" fill="#000001" />
          <path opacity="0.2" fill-rule="evenodd" clip-rule="evenodd" d="M14.6035 4.18967C14.7761 4.48861 14.6737 4.87085 14.3747 5.04344L11.7767 6.54344C11.4777 6.71603 11.0955 6.61361 10.9229 6.31467C10.7503 6.01574 10.8527 5.6335 11.1517 5.46091L13.7497 3.96091C14.0487 3.78832 14.4309 3.89074 14.6035 4.18967Z" fill="#000001" />
          <path opacity="0.1" fill-rule="evenodd" clip-rule="evenodd" d="M11.8128 1.39874C12.1117 1.57133 12.2141 1.95358 12.0415 2.25251L10.5415 4.85058C10.3689 5.14952 9.98668 5.25194 9.68775 5.07935C9.38882 4.90676 9.2864 4.52452 9.45898 4.22558L10.959 1.62751C11.1316 1.32858 11.5138 1.22615 11.8128 1.39874Z" fill="#000001" />
        </svg>
        <i v-else :class="spinner"></i>
        <p v-if="text" class="zm-loading-text">
          {{ text }}
        </p>
      </div>
    </div>
  </transition>
</template>

<script>
  export default {
    data() {
      return {
        text: null,
        spinner: null,
        background: null,
        fullscreen: true,
        visible: false,
        customClass: ''
      };
    },

    methods: {
      handleAfterLeave() {
        this.$emit('after-leave');
      },
      setText(text) {
        this.text = text;
      }
    }
  };
</script>

<style lang="scss">
  @import "../../scss/mixins/mixins";
  @import "../../scss/common/var";

  @include b(loading-parent) {
    @include m(relative) {
      position: relative !important;
    }

    @include m(hidden) {
      overflow: hidden !important;
    }
  }

  @include b(loading-mask) {
    position: absolute;
    z-index: 100;
    background-color: rgba(255, 255, 255, .9);
    margin: 0;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    transition: opacity 0.3s;

    @include when(fullscreen) {
      position: fixed;

      .zm-loading-spinner {
        margin-top: #{- $--loading-fullscreen-spinner-size / 2};

        .circular {
          height: $--loading-fullscreen-spinner-size;
          width: $--loading-fullscreen-spinner-size;
        }
      }
    }
  }

  @include b(loading-spinner) {
    top: 50%;
    margin-top: #{- $--loading-spinner-size / 2};
    width: 100%;
    text-align: center;
    position: absolute;

    .zm-loading-text {
      color: $--color-primary;
      margin: 3px 0;
      font-size: 14px;
    }

    .circular {
      height: $--loading-spinner-size;
      width: $--loading-spinner-size;
      animation: loading-rotate 2s linear infinite;
    }

    .path {
      animation: loading-dash 1.5s ease-in-out infinite;
      stroke-dasharray: 90, 150;
      stroke-dashoffset: 0;
      stroke-width: 2;
      stroke: $--color-primary;
      stroke-linecap: round;
    }

    i {
      color: $--color-primary;
    }
  }

  .zm-theme--dark{
    @include b(loading-mask) {
      background-color: #252a30;
    }
    @include b(loading-spinner) {
      .circular path{
        fill: #fff;
      }
    }
  }

  .zm-loading-fade-enter,
  .zm-loading-fade-leave-active {
    opacity: 0;
  }

  @keyframes loading-rotate {
    100% {
      transform: rotate(360deg);
    }
  }

  @keyframes loading-dash {
    0% {
      stroke-dasharray: 1, 200;
      stroke-dashoffset: 0;
    }
    50% {
      stroke-dasharray: 90, 150;
      stroke-dashoffset: -40px;
    }
    100% {
      stroke-dasharray: 90, 150;
      stroke-dashoffset: -120px;
    }
  }
</style>
